import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { SUPPORT_EMAIL, SUPPORT_MAILTO } from '@/config/support';
import { usePageMeta } from '@/hooks/usePageMeta';

const Legal = () => {
  usePageMeta({
    title: 'Legal Notice — CultureLens',
    description:
      'Legal notice and company information for CultureLens, operated by IV Talent.',
    canonical: 'https://culturelens.org/legal',
  });
  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-6 py-16 max-w-3xl">
        <Button variant="ghost" asChild className="mb-8">
          <Link to="/" className="gap-2">
            <ArrowLeft className="h-4 w-4" /> Back to Home
          </Link>
        </Button>

        <h1 className="text-3xl font-bold mb-8">Legal Notice</h1>

        <div className="prose prose-neutral dark:prose-invert max-w-none space-y-6 text-muted-foreground">
          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">Company Information</h2>
            <p>
              IV Talent<br />
              Email: <a href={SUPPORT_MAILTO} className="underline">{SUPPORT_EMAIL}</a>
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">Disclaimer</h2>
            <p>
              The information provided on this website is for general informational purposes only. 
              While we strive to keep the information up to date and accurate, we make no representations 
              or warranties of any kind, express or implied, about the completeness, accuracy, reliability, 
              suitability, or availability of the website or the information, products, services, or 
              related graphics contained on the website.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">Limitation of Liability</h2>
            <p>
              In no event shall IV Talent be liable for any loss or damage including without limitation, 
              indirect or consequential loss or damage, or any loss or damage whatsoever arising from 
              loss of data or profits arising out of, or in connection with, the use of this website.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">External Links</h2>
            <p>
              Through this website you may be able to link to other websites which are not under the 
              control of IV Talent. We have no control over the nature, content, and availability of 
              those sites. The inclusion of any links does not necessarily imply a recommendation or 
              endorse the views expressed within them.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">Governing Law</h2>
            <p>
              These terms and conditions are governed by and construed in accordance with applicable law, 
              and any disputes relating to these terms and conditions will be subject to the exclusive 
              jurisdiction of the courts.
            </p>
          </section>
        </div>

        <p className="text-sm text-muted-foreground mt-12">
          Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', year: 'numeric' })}
        </p>
      </div>
    </div>
  );
};

export default Legal;
